module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/_library.js
// module id = 62
// module chunks = 21